export default __webpack_public_path__ + "1ed883a04900782fd47b0ed84ccb174c.svg";